import campaignLandingData from "@/data/campaign-landing-pages.json";
import type { BookCallPopupVariant } from "@/lib/book-call-popup-copy";
import type { SiteLocale } from "@/lib/i18n/config";

type CampaignLandingPage = {
  locale: SiteLocale;
  slug: string;
  bookCallVariant: BookCallPopupVariant;
  toolGroups: string[];
};

const pages = campaignLandingData.pages as Record<string, CampaignLandingPage>;

/** Ad landing pages exist in one locale only, under the campaign URL namespace. */
export function resolveCampaignLandingKey(path: string, locale: string): string | null {
  return Object.entries(pages).find(([, page]) => page.locale === locale && page.slug === path)?.[0] ?? null;
}

export function getCampaignLandingPage(key: string): CampaignLandingPage | undefined {
  return pages[key];
}

export function listCampaignLandingKeys(): string[] {
  return Object.keys(pages);
}

/**
 * True for an ad landing page path (`/sv/fokus/ai-konsult`). Site chrome uses it to
 * drop the navbar and footer there, so the page has one way forward: booking.
 */
export function isCampaignLandingPathname(pathname: string): boolean {
  const [locale, ...segments] = pathname.split("/").filter(Boolean);
  return resolveCampaignLandingKey(segments.join("/"), locale) !== null;
}
